import {ILabelValue} from '../../../interfaces/utils';

export const NUTRITIONAL_DRESSING: ILabelValue[] = [
  {
    label: 'Aguacate',
    value: 'aguacate'
  },
  {
    label: 'Aderezo casero',
    value: 'aderezo casero'
  },
  {
    label: 'Aderezo comercial',
    value: 'aderezo comercial'
  },
  {
    label: 'Mayonesa',
    value: 'mayonesa'
  },
  {
    label: 'Mostaza',
    value: 'mostaza'
  }
];
